module.exports = __webpack_public_path__ + "71dbd5520020b7e34e0f600ab27e7265.fbx";